import { ZapierOfficialIcon } from '@/shared/ui';

export const integrationsList = [
  {
    heading: 'Zapier integration',
    Icon: ZapierOfficialIcon,
    text: "With Zapier's extensive app integrations, you can automate essential tasks like generating new leads or sending review requests - all without manual effort",
    url: '/integrations/zapier',
  },
];
